<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="输入姓名模糊检索（支持空格隔开多人检索）" prefix-icon="el-icon-search"
                              clearable
                              @clear="initOfflineProjects"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initOfflineProjects" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initOfflineProjects" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                    <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button>
                </div>
                <div>
                    <!-- <el-button type="success" @click="exportData" icon="el-icon-download">
                         
                    </el-button>  -->
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加人员
                    </el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="showNankaiApplyView">
                        入校申请
                    </el-button>
                </div>
            </div>

            <!-- 高级搜索条件  -->
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row>
                        <el-col :span="6">
                            姓名:
                            <el-input v-model="searchValue.name" placeholder="姓名" clearable size="mini"
                                       style="width: 130px;"></el-input>
                        </el-col>
                        <el-col :span="6">
                            身份证号:
                            <el-input v-model="searchValue.id" placeholder="身份证号" clearable size="mini"
                                       style="width: 130px;"></el-input>
                        </el-col>
                        <el-col :span="6">
                            手机号:
                            <el-input v-model="searchValue.phone" placeholder="手机号" clearable size="mini"
                                       style="width: 130px;"></el-input>
                        </el-col>
                        <el-col :span="6">
                            人员所属:
                            <el-select clearable multiple size="mini" style="width: 200px" v-model="searchValue.pBelongs" filterable  @change="$forceUpdate()"  placeholder="请选择">
                                    <el-option 
                                            v-for="str in belongSet"
                                            :key="str"
                                            :label="str"
                                            :value="str">
                                    </el-option>
                                </el-select>
                        </el-col>
                         
 
                    </el-row>
                    <el-row style="margin-top: 10px" type="flex" justify="end">
                        
   
                        <el-col :span="5" :offset="5">
                            <el-button size="mini">取消</el-button>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="initOfflineProjects('advanced')">搜索</el-button>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <!-- 标题列 --->
        <div style="margin-top: 10px">
            <el-table
                    :data="projects"
                    border
                    :row-class-name="tableAddClass"
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    ref="projectTable"
                    style="width: 100%;"
                    :row-key="row=>row.pCode"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}">
                <el-table-column
                        type="selection" :reserve-selection="true"
                        width="55">
                </el-table-column>
                <el-table-column
                        prop="pName"
                        align="center"
                        label="姓名"
                        width="140">
                </el-table-column>
                <el-table-column
                        prop="pSex"
                        align="center"
                        label="姓别"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="pPhone"
                        align="center"
                        label="手机号"
                        width="140">
                </el-table-column>
                <el-table-column
                        prop="pId"
                        align="center"
                        label="身份证号码"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="pCar"
                        align="center"
                        label="车牌号"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="pBelong"
                        align="center"
                        label="人员所属"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="cTime"
                        align="center"
                        label="创建时间"
                        width="220">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        align="center"
                        width="200"
                        label="操作">
                    <template slot-scope="scope">
                        <!-- <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini" type="warning" v-has>锁定</el-button> -->
                        <!-- <el-button @click="showProjectDetail(scope.row)" style="padding: 3px" type="primary" size="mini">明细</el-button> -->
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" type="primary" size="mini">编辑</el-button>
                        <!-- <el-button style="padding: 3px" size="mini" type="primary">查看高级资料</el-button> -->
                        <!-- <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除 -->
                        <!-- </el-button>   -->
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
         
        <!-- 修改和添加模块 -->
        <el-dialog
                :title="title"
                label-width="80px"
                :visible.sync="dialogVisible"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                width="30%">
            <div>
                <el-form :model="project"  label-width="120px" :rules="rules" ref="empForm">
                            <el-form-item label="姓名:" prop="pName">
                                <el-input  clearable size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="project.pName"
                                          placeholder="请输入姓名"></el-input>
                            </el-form-item>
                            <el-form-item label="性别:" prop="pSex">
                                <el-radio-group v-model="project.pSex">
                                    <el-radio label="男">男</el-radio>
                                    <el-radio label="女">女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="电话:" prop="pPhone">
                                <el-input clearable size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="project.pPhone"
                                          placeholder="请输入电话"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证:" prop="pId">
                                <el-input clearable size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="project.pId"
                                          placeholder="请输入身份证号"></el-input>
                            </el-form-item>
                            <el-form-item  label="人员所属:" prop="pBelong">
                                <el-select clearable size="mini" style="width: 200px" v-model="project.pBelong" filterable  @change="$forceUpdate()"  placeholder="请选择">
                                    <el-option 
                                            v-for="str in belongSet"
                                            :key="str"
                                            :label="str"
                                            :value="str">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="车牌:" prop="pCar">
                                <el-input clearable  @input="(e) => { project.pCar = e.toUpperCase().replace(/^\s+|\s+$/g, '') }" size="mini" style="width: 200px;" prefix-icon="el-icon-edit" v-model="project.pCar"
                                          placeholder="请输入车牌号"></el-input>
                            </el-form-item>
                        
                    
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="doAddEmp">确 定</el-button>
            </span>
            </el-dialog>        
            <!-- <el-dialog
                :title="title"
                label-width="80px"
                :visible.sync="dialogVisible"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                width="30%">
                    <div>
                        <el-form :model="project"  label-width="120px" :rules="rules" ref="empForm">
                                    <el-form-item label="姓名:" prop="pName">
                                        <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="project.pName"
                                                placeholder="请输入姓名"></el-input>
                                    </el-form-item>
                                    <el-form-item label="性别:" prop="pSex">
                                        <el-radio-group v-model="project.pSex">
                                            <el-radio label="男">男</el-radio>
                                            <el-radio label="女">女</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="电话:" prop="pPhone">
                                        <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="project.pPhone"
                                                placeholder="请输入电话"></el-input>
                                    </el-form-item>
                                    <el-form-item label="身份证:" prop="pId">
                                        <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="project.pId"
                                                placeholder="请输入身份证号"></el-input>
                                    </el-form-item>
                                    <el-form-item label="车牌:" prop="pCar">
                                        <el-input  @input="(e) => { project.pCar = e.toUpperCase().replace(/^\s+|\s+$/g, '') }" size="mini" style="width: 200px;" prefix-icon="el-icon-edit" v-model="project.pCar"
                                                placeholder="请输入车牌号"></el-input>
                                    </el-form-item>
                                
                            
                        </el-form>
                    </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="doAddEmp">确 定</el-button>
                </span>
            </el-dialog> -->

            <el-dialog
                title='南开进校申请'
                label-width="80px"
                :visible.sync="nankaiApply"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                width="30%">
                    <div>
                        <el-form :model="record"  label-width="120px" :rules="rules" ref="empForm">
                            <el-form-item label="是否有邀请码:" prop="radio">
                                <el-radio-group v-model="record.q1">
                                    <el-radio label="Y">是</el-radio>
                                    <el-radio label="N">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item v-if="record.q1=='N'" label="对接部门:" prop="pCode">
                                <el-select size="mini" style="width: 180px" v-model="record.q12" filterable  @change="$forceUpdate()"  placeholder="请选择">
                                    <el-option 
                                            v-for="(r,indexk) in departments"
                                            :key="r.value"
                                            :label="r.label"
                                            :value="r.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            
                            <el-form-item  v-if="record.q1 != 'N'" label="邀请码:" prop="specialty">
                                <el-input size="mini" style="width: 180px" prefix-icon="el-icon-edit"
                                          v-model='record.q011' placeholder="请输入邀请码"></el-input>
                            </el-form-item>
                            <el-form-item  label="来校原因:" prop="pCode">
                                <el-select size="mini" style="width: 180px" v-model="record.q13" filterable    placeholder="请选择">
                                    <el-option   key="0" label=" " value="0">   </el-option>
                                    <el-option   key="1" label="交流合作" value="1">   </el-option>
                                    <el-option   key="2" label="招聘宣讲" value="2">   </el-option>
                                    <el-option   key="3" label="送货维护" value="3">   </el-option>
                                    <el-option   key="4" label="其他" value="4">   </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="具体事由:" prop="q7">
                                <el-input size="mini" style="width: 180px" prefix-icon="el-icon-edit"  
                                          v-model="record.q7" placeholder="请输入进校具体事由"></el-input>
                            </el-form-item>
                            <el-form-item label="联系老师:" prop="q11">
                                <el-input size="mini" style="width: 180px" prefix-icon="el-icon-edit"  
                                          v-model="record.q11" placeholder="请输入学校对接老师"></el-input>
                            </el-form-item>
                            <el-form-item prop="apSTime"  label="进校时间:">
                                <el-date-picker style="width: 180px"
                                        v-model="record.apSTime"
                                        type="date"
                                        size="mini"
                                        @input="$forceUpdate()" 
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="{
                                                    disabledDate: (time) => {
                                                        const now = Date.now();
                                                        const day = 24 * 60 * 60 * 1000; 
                                                            return (time.getTime() < now - day || // 今天之前不可选
                                                                    time.getTime() > now + day) // 今天之后不可选  
                                                    }
                                                }"  
                                        placeholder="进校时间：">
                                </el-date-picker>
                            </el-form-item>

                            <el-form-item prop="apSTime"  label="离校时间:">
                                <el-date-picker style="width: 180px"
                                        v-model="record.apETime"
                                        type="date"
                                        size="mini"
                                        @input="$forceUpdate()" 
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="{
                                                    disabledDate: (time) => {
                                                        if(this.record.apSTime){
                                                        const now = Date.now();
                                                        const day = 24 * 60 * 60 * 1000; 
                                                            return (time.getTime() <  new Date(this.record.apSTime).getTime() - day
                                                                    ||
                                                                    time.getTime() > now + day 
                                                                     )
                                                        }
                                                    }
                                                }"
                                        placeholder="离校时间：">
                                </el-date-picker>
                            </el-form-item>
                             


                        </el-form>
                    </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="nankaiApply = false">取 消</el-button>
                    <el-button type="primary" @click="doAddRecord">确 定</el-button>
                </span>
            </el-dialog>
    </div>
</template>




<script>
    import {Message} from 'element-ui';
    export default {
        name: "personInfo",
        data() {
            return {
               
                searchValue: {
                    politicId: null,
                    nationId: null,
                    jobLevelId: null,
                    posId: null,
                    engageForm: null,
                    departmentId: null,
                    beginDateScope: null,
                    pBelong:null,
                    year:new Date()
                },
                  
                showChangeDetail : false,
                showDetail : false,
                restaurants : [],
                restaurantsSpecs : [],
                places: [],
                user:"",
                title: '',
                pCode:'',
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showAdvanceSearchView: false,
                allDeps: [],
                upFilePlat:'',
                addFileTitleName: "上传文件窗口",
                addFileName: "",
                addArr: [],
                projects: [],
                departments:[],
                loading: false,
                popVisible: false,
                popVisible2: false,
                dialogVisible: false,
                nankaiApply:false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
                nations: [],
                joblevels: [],
                politicsstatus: [],
                positions: [],
                belongSet:[],
                tiptopDegrees: ['本科', '大专', '硕士', '博士', '高中', '初中', '小学', '其他'],
                options: [ ],
                inputDepName: '所属部门',
                project: {
                
                },
                details:[],
                record:{
                    q1:"Y"
                },
                detail:{
                    count:1,
                    type:0,
                    gov:'0',
                    budgutPrice:'',
                    pCode:'',
                    unit:'',
                    price:'',
                    costPrice:''
                },
                materials:[],
                materialNameTemp:'',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    pName: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                    pSex: [{required: true, message: '请输入性别', trigger: 'blur'}],
                    q11:[{required: true, message: '请输入联系老师', trigger: 'blur'}],
                    pId: [{required: true, message: '请输入身份证号码', trigger: 'blur'}, {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '身份证号码格式不正确',
                        trigger: 'blur'
                    }],
                    pPhone: [{required: true, message: '请输入手机号码', trigger: 'blur'}, {
                        pattern: /(^(13[0-9]|14[5-9]|15[0-3,5-9]|16[6]|17[1-8]|18[0-9]|19[1,8,9])\d{8}$)/,
                        message: '手机号格式不正确',
                        trigger: 'blur'
                    }],
                    pCar: [{required: false, message: '请输入车牌号', trigger: 'blur'}, {
                        pattern: /(^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-HJ-NP-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1})|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([DF][A-HJ-NP-Z0-9][0-9]{4})|([0-9]{5}[DF])))$)/,
                        message: '号牌不正确',
                        trigger: 'blur'
                    }, {
                        pattern: /(^.{0,8}$)/,
                        message: '号牌长度不正确',
                        trigger: 'blur'
                    }]
                    
                }
            }
        },
        mounted() {
            this.initOfflineProjects();
            this.initBelongSet();
            // this.initData();
           
        },
        methods: {
            rowKey(row){
                console.log( row.pCode)
                row.pCode;
            },
            handleSelectionChange (val) {
                console.log(val)
            },
            tableAddClass({row,rowIndex}) {
                if (row.pStatus == '0') {
                    return 'tr-gray';
                }else if(row.pStatus == '1'){
                    return 'tr-blue';
                }else if(row.pStatus == '2'){
                    return 'tr-green';
                }else if(row.pStatus == '3'){
                    return 'tr-yellow';
                }else {
                    return '';
                }
            },
            //1、使用插槽（推荐）
            getChangeType(e,z) {

                if('detailType' == z){
                        if ('0' == e) { //dictValue，dictLabel保持和上面定义一致
                            return '制作类';
                        }else if('1' == e){
                            return '搭建类';
                        }else if('2' == e){
                            return '运费';
                        }else if('3' == e){
                            return '其他';
                        }
                }
               
            },

            exportTask() {
                let selected = this.$refs.projectTable.selection
                let arr = [];
                for(let temp in selected){
                    arr.push(selected[temp].projectCode)

                }
                window.open('/employee/basic/export', '_parent');
            },
            emptyEmp() {
                this.project = {
                    "id":"",
                    "pCode":"",
                    "pName":"",
                    "pCar":"津",
                    "pBelong":"",
                    "cTime":"",
                    "gTime":""
                }
                this.inputDepName = '';
            },
            showProjectDetail(data){
                this.showDetail = true;
                this.detail.pCode = data.pCode;
                this.pCode = data.pCode;
                this.project = data;
                this.project.pDCompany =  this.project.pDCompany =='0'?'扬帆永顺':'博雅明德'
                this.project.pDLink='杨斌 13820251532';
                this.initDetails();
            },
            initDetails(){
                this.getRequest("/yl/offline/details/"+this.pCode).then(resp => {
                    if (resp) {
                        this.details = resp.data;
                    }
                })
            },
            showEditEmpView(data) {
                 
                this.title = '编辑项目信息';
                this.project = data;
                // this.inputDepName = data.department.name;
                this.dialogVisible = true;
            },
            initBelongSet(){
                this.getRequest("/yl/apply/getPBelongSet").then(resp => {
                    if (resp) {
                        this.belongSet = resp.obj;
                    }
                })
            },
            showNankaiApplyView() {
                let selected = this.$refs.projectTable.selection
                if(selected.length<1){
                    Message.warning({message: '请先选择申请的人员'})
                    return
                }
                 // this.inputDepName = data.department.name;
                 this.nankaiApply = true;
                 this.getRequest("/yl/apply/departments").then(resp => {
                    if (resp) {
                        this.departments = resp.obj;
                    }
                })
             },
            deleteDetail(data){
                this.$confirm('此操作将永久删除【' + data.detailName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/yl/offline/detail/" + data.detailCode).then(resp => {
                        if (resp) {
                            this.initDetails();
                            this.initOfflineProjects();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.name + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/employee/basic/" + data.id).then(resp => {
                        if (resp) {
                            this.initOfflineProjects();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddDetail() {
                this.detail.pId = this.user.username;
                this.detail.pName = this.user.name;
                if (this.detail.id) {
                    this.$refs['empForm1'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/offline/project/detail", this.detail).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initOfflineProjects();
                                    this.initDetails();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm1'].validate(valid => {
                        if (valid) {
                            this.postRequest("/yl/offline/project/detail", this.detail).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initOfflineProjects();
                                    this.initDetails();
                                }
                            })
                        }
                    });
                }
                this.showChangeDetail = false;
                this.emptyDetail();
            },
            emptyDetail(){
                this.detail={
                    count:1,
                    detailName:'',
                    type:0,
                    gov:'0',
                    budgutPrice:'',
                    pCode:this.pCode,
                    unit:'',
                    price:'',
                    costPrice:''
                }
            },
            exportData(){

            },
            doAddEmp() {
                if (this.project.id) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/apply/person", this.project).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initOfflineProjects();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/yl/apply/person", this.project).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initOfflineProjects();
                                }
                            })
                        }
                    });
                }
            },
            doAddRecord() {
                let selected = this.$refs.projectTable.selection
                let arr = [];
                for(let temp in selected){
                    arr.push(selected[temp].pCode)
                }
                this.record.otherParam = JSON.stringify(this.record) 
                this.record.personIds = arr
                this.$refs['empForm'].validate(valid => {
                    if (valid) {
                        this.postRequest("/yl/apply", this.record).then(resp => {
                            if (resp) {
                                debugger
                                this.nankaiApply = false;
                                Message.info({message: resp.obj})
                                this.initOfflineProjects();
                            }
                        })
                    }
                });
            },
            
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.project.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initData() {
                this.user = JSON.parse(window.sessionStorage.getItem("user"));
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initOfflineProjects();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initOfflineProjects('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加人员';
                
                this.dialogVisible = true;
            },
            initOfflineProjects(type) {
                this.loading = true;
                // let reqParam = {projectNameLike:this.keyword};
                this.searchValue['keyword']=this.keyword
                this.searchValue['pageNo']=this.page
                this.searchValue['pageSize']=this.size
                this.postRequest('/yl/apply/person/getPerson', this.searchValue).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.projects = resp.data;
                        this.total = resp.total;
                    }
                });

               
            },
            

        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
    .tr-gray{
        background-color: #c0c4cc !important;
    }
    .tr-blue{
        background-color: #B2E0FF !important;
    }
    .tr-green{
        background-color: #9EEA6A !important;
    }
    .tr-yellow{
        background-color: #FED55F !important;
    }
    .el-radio{
        margin-top: 8px !important;
    }
    .el-autocomplete-suggestion{
        width: auto!important;
    }
    .el-table__fixed-right {
        height: 100% !important;
    }
    .el-table__fixed{
        height: 100% !important;
    }


</style>
